import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const reprovarConteudo = async (id: number, pendencia: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/conteudo/reprovar/${id}`, pendencia, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao reprovar conteúdo';
    throw new Error(errorMessage);
  }
};

export const aprovarConteudo = async (id: number) => {
  try {
    const response = await api.put(`/conteudo/aprovar/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao aprovar conteúdo';
    throw new Error(errorMessage);
  }
};